import React from 'react';

interface Props {
  value: number;
  onChange: (val: number) => void;
  placeholder?: string;
  min?: number;
  max?: number;
  style?: React.CSSProperties;
  className?: string;
}

export default function InputNombre({
  value, onChange, placeholder = '0', min = 0, max, style, className
}: Props) {
  return (
    <input
      type="number"
      value={value === 0 ? '' : value}
      onChange={e => onChange(e.target.value === '' ? 0 : +e.target.value)}
      placeholder={placeholder}
      min={min}
      max={max}
      style={style}
      className={className}
      onFocus={e => e.target.select()}
    />
  );
}